import { render, staticRenderFns } from "./abilityBoard.vue?vue&type=template&id=7be5bb63&scoped=true&"
import script from "./abilityBoard.vue?vue&type=script&lang=js&"
export * from "./abilityBoard.vue?vue&type=script&lang=js&"
import style0 from "./abilityBoard.vue?vue&type=style&index=0&id=7be5bb63&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be5bb63",
  null
  
)

export default component.exports